const API_BASE = process.env.VUE_APP_API_ROOT
export default {
  USER_DATA: API_BASE + '/instance/{instanceId}/tag/{id}',
  CONFIGURATION: API_BASE + '/instance/{id}',
  REFUND: API_BASE + '/instance/{instanceId}/tag/{id}/refunds'
}
